import React from "react";
import ReactDOM from "react-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import App from "./App";
import reportWebVitals from "./reportWebVitals";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root"),
  document.addEventListener('keydown', event => {
    if (event.ctrlKey || event.key === 'F12') {
      event.preventDefault();
    }
  })
);

reportWebVitals();
